import React, { useState } from 'react';
import { createSafeUrl } from '../../utils/safeUrl';
import './Contact.scss';

interface ContactForm {
  name: string;
  email: string;
  subject: string;
  message: string;
}

const Contact: React.FC = () => {
  const [contactForm, setContactForm] = useState<ContactForm>({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const contactInfo = {
    address: '1820 Miccosukee Commons Drive, Tallahassee, FL 32308',
    phone: '(850) 765-8120',
    fax: '(850) 270-7733',
    email: 'info@ffps.pro',
    hours: {
      weekdays: 'Mon-Fri: 8:00AM - 5:00PM',
      saturday: ''
    }
  };

  const mapUrl = createSafeUrl(`https://www.google.com/maps?q=${encodeURIComponent(contactInfo.address)}&output=embed`);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Contact form submitted:', contactForm);
    alert('Thank you for your message! We will get back to you soon.');
    setContactForm({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setContactForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1>Contact Us</h1>
        <p>Get in touch with us for any questions about our psychiatric services or to schedule an appointment</p>
      </div>

      <div className="contact-content">
        <div className="contact-info">
          <h2>Get In Touch</h2>
          <div className="info-item">
            <h3>Address</h3>
            <p>1820 Miccosukee Commons Drive<br />Tallahassee, FL 32308</p>
          </div>
          <div className="info-item">
            <h3>Email</h3>
            <p>info@ffps.pro</p>
          </div>
          <div className="info-item">
            <h3>Phone</h3>
            <p>(850) 765-8120</p>
          </div>
          <div className="info-item">
            <h3>Fax</h3>
            <p>(850) 270-7733</p>
          </div>
          <div className="info-item">
            <h3>Office Hours</h3>
            <p>Monday - Friday: 8:00 AM - 5:00 PM</p>
          </div>
        </div>

        <div className="contact-form">
          <h2>Send us a Message</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={contactForm.name}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={contactForm.email}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={contactForm.subject}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={contactForm.message}
                onChange={handleChange}
                rows={5}
                required
              />
            </div>
            
            <button type="submit" className="submit-btn">Send Message</button>
          </form>
        </div>
      </div>

      <div className="map">
        <iframe
          style={{ border: 0, width: '100%', height: '450px' }}
          src={mapUrl}
          frameBorder="0"
          allowFullScreen
          title="Florida First Psychiatry Location"
        />
      </div>
    </div>
  );
};

export default Contact;

